function handlehubnav() {
  const header = document.querySelector('.injected-header .fixed-header');
  const hubnav = document.querySelector('.top-nav');
  if (hubnav && hubnav.classList.contains('top-nav-fixed')) {
    if (header) {
      hubnav.style.setProperty('top', '70px', 'important');
    } else {
      hubnav.style.setProperty('top', '100px', 'important');
    }
  } else if (hubnav && !hubnav.classList.contains('top-nav-fixed')) {
    hubnav.style.setProperty('top', '0px', 'important');
  }
}

function localselector() {
  if (document.querySelector('.current-locale')) {
    document.querySelector('.current-locale').addEventListener('click', function(e) {
      document.querySelector('.current-locale').parentNode.classList.toggle('hover');
    });
  }
}

function hubnavClose() {
  const close = document.querySelector('.exit');
  const hubnav = document.querySelector('.top-nav');
  if (close && hubnav) {
    close.addEventListener('click', function() {
      hubnav.style.setProperty('top', '0px', 'important');
    });
  }
}

function hideNav() {
  if (!window.obData || !window.obData.hideStreamNav) {
    return;
  }
  const streampage = document.querySelector('.listing-page');
  const itempage = document.querySelector('.single-page');
  if (streampage || itempage) {
    const streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;
    if (streamPageID) {
      const config = window.obData.hideStreamNav;
      const hubnav = document.querySelector('.top-nav');
      if (config.includes(streamPageID) && hubnav) {
        document.body.classList.add('no-hubnav');
        hubnav.style.display = 'none';
      }
    }
  }
}

export { handlehubnav, localselector, hubnavClose, hideNav };



// WEBPACK FOOTER //
// ./scriptPartials/handlehubnav.js